import { connect } from 'react-redux';
import KodeGuru from '../../../views/Kurikulum/MataPelajaran/KodeGuru.view.js';
import { getStudent } from '../../../states/thunks/student.thunk.js';
import { getClasses, getSubjectOptions, getClassesOptions, getStaffScheduleOptions, getStaffScheduleMoveOptions, getPeriodsOptions } from '../../../states/thunks/options.thunk.js';
import { listCodeTeacher, deleteCodeTeacher, listTeacherExcel, saveCodeTeacher, editCodeTeacher, listDeleteTeacher, listCodeNonTeacher, activateCodeTeacher} from '../../../states/thunks/academics.thunk.js';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetStudent: () => dispatch(getStudent()),
    handleActivateCodeTeacher: (payload, goBack) => dispatch(activateCodeTeacher(payload, goBack)),
    handleDeleteCodeTeacher: (payload, goBack) => dispatch(deleteCodeTeacher(payload, goBack)),
    handleListCodeTeacher: (payload, goBack) => dispatch(listCodeTeacher(payload, goBack)),
    handleListDeleteCodeTeacher: (payload, goBack) => dispatch(listDeleteTeacher(payload, goBack)),
    handleListCodeNonTeacher: (payload, goBack) => dispatch(listCodeNonTeacher(payload, goBack)),
    handleSaveCodeTeacher: (payload, goBack) => dispatch(saveCodeTeacher(payload, goBack)),
    handleEditCodeTeacher: (payload, goBack) => dispatch(editCodeTeacher(payload, goBack)),
    handleListTeacherExcel: (payload, goBack) => dispatch(listTeacherExcel(payload, goBack)),
    getSubjectOptions: payload => dispatch(getSubjectOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getStaffScheduleOptions: payload => dispatch(getStaffScheduleOptions(payload)),
    getStaffScheduleMoveOptions: payload => dispatch(getStaffScheduleMoveOptions(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
 
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(KodeGuru);
